import loadable from '@loadable/component';

const LoadableMarkdownRenderer = loadable(() => import('./markdownRenderer'));

export default LoadableMarkdownRenderer;
